export enum enteteTableauListeNaturesRubriquesPaieEnum {
	compte = 'Compte',
	natureChargeResidentiel = 'Nature charge résidentiel',
	natureChargeBureau = 'Nature charge bureau',
}